import { ScheduledLessonsDTO } from '../../../src_server/entity/dto/ScheduledLessonsDTO';


import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';


import { LessonReservationDTO } from '../../../src_server/entity/dto/LessonReservationDTO';


import { LessonCheckResultDTO } from '../../../src_server/entity/dto/LessonCheckResultDTO';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';


import { Lessons } from '../../../src_server/entity/generated/Lessons';export class DaLessonsService extends GeneratedBizBase{
  async getLessonByShiftTableId(shift_table_id: number): Promise<Response<ScheduledLessonsDTO>> {
    return super.restCall<Response<ScheduledLessonsDTO>>('get', '/v1/DaLessons/getLessonByShiftTableId', arguments);
  }
  async getLessonInTheDay(date: Date,building_id: string): Promise<Response<LessonDTO[]>> {
    return super.restCall<Response<LessonDTO[]>>('post', '/v1/DaLessons/getLessonInTheDay', arguments);
  }
  async reservation(student_user_id: string,teacher_user_id: string,start_dt: Date,end_dt: Date,shift_table_id: number,day_of_week: boolean): Promise<Response<LessonReservationDTO>> {
    return super.restCall<Response<LessonReservationDTO>>('post', '/v1/DaLessons/reservation', arguments);
  }
  async checkCancelLimit(original_class_id: number): Promise<Response<LessonCheckResultDTO>> {
    return super.restCall<Response<LessonCheckResultDTO>>('post', '/v1/DaLessonsService/checkCancelLimit', arguments);
  }
  async cancel(original_class_id: number,reason: string,building_id: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/DaLessonsService/cancel', arguments);
  }
  async deleteLesson(original_class_id: number): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/DaLessonsService/deleteLesson', arguments);
  }
  async reservationCommit(lesson: Lessons,building: string): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/DaLessonsService/reservationCommit', arguments);
  }
}
